<template>
<modal name="cocorowa-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="permissionType == 2">
    <p style="font-size: 120%;">転職活動の準備ができているか<br>チェックリストを確認してね！</p>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >履歴書・職歴書の書き方、本当に大丈夫？
      </p>
    </div>
    <br/>
    <div class="text-center">
      <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
      onClick="window.open('https://bit.ly/3aGWmcW', '_blank');" ><span>落ちる人の書き方を確認</span></button>
      <!-- https://bit.ly/3aGWmcW -->
    </div>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <img src="/static/renew_img/check_icon.png" style="width:40px" >退職手続き終わっていますか？
      </p>
    </div>
    <br/>
    <div class="text-center">
      <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
      onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>心配な人は詳細を確認</span></button>
    </div>
    <br/>
  </div>
  <div class="setting" v-if="permissionType == 3">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">＼東京23区のお仕事限定!!／</p>
      <p style="font-size: 120%;">今作成した履歴書をもとに<br>プロがおすすめの{{baite_title}}先をご紹介します!!</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/mynabi_logo.png" style="width:100%" >
        </p>
      </div>
      <p style="font-size: 120%;">ご同意いただいた方には追ってメールが<br>届きますので、ご確認お願いいたします！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <el-checkbox v-model="isAgree" style="-moz-transform:		scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">同意して無料相談を希望</el-checkbox>
        </p>
      </div>
      <br/>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          株式会社マイナビ アルバイト紹介サービス<a href="https://baito.mynavi.jp/user/html/kiyaku.html#tab5" target="_blank">利用規約</a>、<a href="https://baito.mynavi.jp/user/html/privacy.html#tab5" target="_blank">個人情報の取り扱いについて</a>
          <br/>Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針について</router-link>
        </p>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-mynabi-consult');">同意する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br/>
      <div class="text-center" v-if="false">
        <el-button id="send-adtop-pdf" type="success"
          @click="$eventHub.$emit('send-adtop-scout');closeDialog();">全てに同意してスカウトを直接受け取る</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・無料相談をご希望いただいた方には、順次ご連絡させていただきます。<br/>少々お待ちいただきますよう予めご了承ください。
      </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">同意しない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
    </div>
  </div>
  <div class="setting" v-if="permissionType == 4">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">東京、神奈川、千葉、埼玉の方 限定！</p>
      <p style="font-size: 120%;">今作成した履歴書をもとに<br>プロが好条件の看護師の勤め先をご紹介します！</p>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/cocorowa_yagish_logo.png" style="width:100%" >
        </p>
      </div>
      <p style="font-size: 120%;">ご同意いただいた方には追ってメールが<br>届きますので、ご確認お願いいたします！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針について</router-link>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <el-checkbox v-model="isAgree" style="-moz-transform:		scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">同意して無料相談を希望</el-checkbox>
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
         style="background-color:#E3165C;border-color:#E3165C;"
          @click="$eventHub.$emit('send-cocorowa-consult');">同意する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
         style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br/>
      <div class="text-center" v-if="false">
        <el-button id="send-adtop-pdf" type="success"
          @click="$eventHub.$emit('send-adtop-scout');closeDialog();">全てに同意してスカウトを直接受け取る</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・無料相談をご希望いただいた方には、順次ご連絡させていただきます。<br/>少々お待ちいただきますよう予めご了承ください。
      </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">同意しない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="setting" v-else>
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 120%;">転職活動の準備ができているか<br>チェックリストを確認してね！</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >履歴書・職歴書の書き方、本当に大丈夫？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3aGWmcW', '_blank');" ><span>落ちる人の書き方を確認</span></button>
        <!-- https://bit.ly/3aGWmcW -->
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px" >効果的な仕事探しをしていますか？<br/>
          作成した履歴書を送って転職先に関する<br/>
          無料相談をしましょう
        </p>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>について
          <br/>
          ㈱アド・トップの転職支援サービス<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報の取り扱い</a>について
        </p>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false" style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-adtop-consult');">規約に同意して無料相談を希望する</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <div class="text-center" v-if="false">
        <el-button id="send-adtop-pdf" type="success" style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-adtop-scout');closeDialog();">全てに同意してスカウトを直接受け取る</el-button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
        ・無料相談は順次にご連絡をさせて頂きます。<br/>少々お時間いただきますので予めご了承ください。
      </p>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" v-if="isSended == false" type="primary" @click="closeDialog();">同意しない</el-button>
        <el-button id="send-adtop-pdf" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:left;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >退職手続き終わっていますか？
        </p>
      </div>
      <br/>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" id="send-adtop-pdf" style="background-color:#0F9934;border-color:#0F9934;"
        onClick="window.open('https://bit.ly/3uT6SV6', '_blank');" ><span>心配な人は詳細を確認</span></button>
      </div>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:false,
      inputEmail:''
    }
  },
  created : function(){
    console.error('Cocorowa created')
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openCocorowaDialog: function (id, html, email) {
      console.error('Cocorowa openDialog')
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.inputEmail = email
      this.$modal.show('cocorowa-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = 4

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'cocorowa_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', '')
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeDialog: function () {
      this.$modal.hide('cocorowa-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'cocorowa_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendMynabiConsult: async function () {
      console.log(this.username);
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.mynabiPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendAdtopScout: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('reqflg', '1')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
        })
    },
    sendCocorowaConsult: async function () {
      console.log(this.username);
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'adtop_dialog')
      formData.append('permission_type', this.permissionType)
      if ((!this.$firebase.user.email && this.inputEmail) || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.cocorowaPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-cocorowa-consult', this.sendCocorowaConsult)
    this.$eventHub.$on('open-cocorowa-dialog', this.openCocorowaDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-cocorowa-consult', this.sendCocorowaConsult)
    this.$eventHub.$off('open-cocorowa-dialog', this.openCocorowaDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
